// Sanitized API documentation data
const endpoints = {
  health: {
    name: "Health Check",
    description: "Monitor the health and status of the API",
    endpoints: [
      {
        id: "health-check",
        name: "Health Check",
        description: "Check if the API is running and healthy",
        method: "GET",
        endpoint: "/health",
        headers: [],
        parameters: [],
        body: null,
        responses: {
          success: {
            "success": true,
            "data": {
              "status": "ok",
              "timestamp": "2025-08-31T04:13:13.168Z"
            }
          }
        }
      }
    ]
  },
  client: {
    name: "Client",
    description: "Manage client profile and balance information",
    endpoints: [
      {
        id: "client-profile",
        name: "Get Client Profile",
        description: "Retrieve the client's profile information including name, email, and balance",
        method: "GET",
        endpoint: "/api/client/profile",
        headers: [
          {
            name: "x-api-key",
            value: "YOUR_API_KEY",
            required: true,
            description: "Your URO API key"
          }
        ],
        parameters: [],
        body: null,
        responses: {
          success: {
            "success": true,
            "data": {
              "client_name": "Test User",
              "client_email": "testuser@example.com",
              "client_balance": 50.0000,
              "client_frozen_balance": 0.5000
            }
          }
        }
      },
      {
        id: "client-balance",
        name: "Get Client Balance",
        description: "Get detailed balance information including available and frozen balance",
        method: "GET",
        endpoint: "/api/client/balance",
        headers: [
          {
            name: "x-api-key",
            value: "YOUR_API_KEY",
            required: true,
            description: "Your URO API key"
          }
        ],
        parameters: [],
        body: null,
        responses: {
          success: {
            "success": true,
            "data": {
              "client_balance": 50.0000,
              "client_frozen_balance": 0.5000,
              "client_max_credit_usage": 100
            }
          }
        }
      }
    ]
  },
  workflows: {
    name: "Workflows",
    description: "Manage and execute AI workflows",
    endpoints: [
      {
        id: "list-workflows",
        name: "List Workflows",
        description: "Get a paginated list of available workflows",
        method: "GET",
        endpoint: "/api/workflows",
        headers: [
          {
            name: "x-api-key",
            value: "YOUR_API_KEY",
            required: true,
            description: "Your URO API key"
          }
        ],
        parameters: [
          {
            name: "page",
            type: "integer",
            required: false,
            default: 1,
            description: "Page number for pagination"
          },
          {
            name: "limit",
            type: "integer",
            required: false,
            default: 10,
            description: "Number of items per page"
          },
          {
            name: "name",
            type: "string",
            required: false,
            description: "Filter workflows by name"
          }
        ],
        body: null,
        responses: {
          success: {
            "success": true,
            "data": {
              "items": [
                {
                  "workflow_definition_id": "550e8400-e29b-41d4-a716-446655440001",
                  "name": "Studio Portrait (AI Headshot)",
                  "description": "Turn your image into a professional Headshot",
                  "average_cost": "0.052000",
                  "workflow_cover_image_url": "https://example.com/image/a1b2c3d4-e5f6-7890-1234-567890abcdef.jpg",
                  "workflow_cover_2_image_url": "https://example.com/image/f1e2d3c4-b5a6-7890-1234-567890fedcba.jpg"
                }
              ],
              "pagination": {
                "page": "1",
                "limit": "10",
                "totalItems": 33,
                "totalPages": 4,
                "hasNextPage": true,
                "hasPrevPage": false
              }
            }
          }
        }
      },
      {
        id: "get-workflow",
        name: "Get Workflow by ID",
        description: "Get detailed information about a specific workflow",
        method: "GET",
        endpoint: "/api/workflows/workflow/{workflow_id}",
        headers: [
          {
            name: "x-api-key",
            value: "YOUR_API_KEY",
            required: true,
            description: "Your URO API key"
          }
        ],
        parameters: [
          {
            name: "workflow_id",
            type: "string",
            required: true,
            in: "path",
            description: "The workflow definition ID"
          }
        ],
        body: null,
        responses: {
          success: {
            "success": true,
            "data": {
              "workflow_definition_id": "550e8400-e29b-41d4-a716-446655440002",
              "name": "URO VTON",
              "description": "Input a picture of your clothes and a picture of a person",
              "average_cost": "0.049190",
              "workflow_cover_image_url": null,
              "workflow_cover_2_image_url": null,
              "parameters": [
                {
                  "workflow_parameter_config_id": 136,
                  "parameter_title": "clothe image",
                  "parameter_name": "clothe_image_url",
                  "data_type": "string",
                  "default_value": null,
                  "is_required": "1",
                  "allowed_values": null,
                  "description": null
                }
              ]
            }
          }
        }
      },
      {
        id: "run-workflow",
        name: "Run Workflow",
        description: "Execute a workflow with specified parameters",
        method: "POST",
        endpoint: "/api/workflows/run-workflow",
        headers: [
          {
            name: "x-api-key",
            value: "YOUR_API_KEY",
            required: true,
            description: "Your URO API key"
          },
          {
            name: "Content-Type",
            value: "application/json",
            required: true,
            description: "Request content type"
          }
        ],
        parameters: [],
        body: {
          "workflow_definition_id": "550e8400-e29b-41d4-a716-446655440003",
          "input_params": {
            "prompt": "A beautiful landscape with mountains and a sunset"
          },
          "webhook_url": "https://your-webhook-url.com/callback",
          "custom_webhook": "https://your-webhook-url.com/callback (same as webhook_url)"
        },
        responses: {
          success: {
            "success": true,
            "data": {
              "workflow_job_id": "660e8400-e29b-41d4-a716-446655440004",
              "status": "processing"
            }
          },
          error: {
            "success": false,
            "error": {
              "message": "Missing required parameter: prompt",
              "code": "VALIDATION_ERROR"
            }
          },
          "webhook_success": {
            "workflow_job_id": "38c046eb-4e20-4bda-9f3b-4e947a7dc954",
            "workflow_definition_id": "fbaa159b-eba8-4196-8a81-2ffbe2bd01b2",
            "input_params": {
              "prompt": "A beautiful landscape with mountains and a sunset"
            },
            "input_texts": {
              "input_text": "A beautiful landscape with mountains and a sunset",
              "negative_prompt": null,
              "positive_prompt": null
            },
            "input_images": {
              "input_image": null,
              "mask_image_url": null,
              "seed_image_url": null
            },
            "results": {
              "results": [
                {
                  "image_id": "580fb129-48e2-44c0-87d7-268c13cdbbb3",
                  "external_url": "https://example.com/image/934ab501-eed8-46a7-9039-ec7e038390b8.jpg",
                  "additional_params": null,
                  "content_type": "image",
                  "content": "https://example.com/image/934ab501-eed8-46a7-9039-ec7e038390b8.jpg"
                }
              ]
            },
            "status": "completed",
            "cost_to_client": 0.0061,
            "created_at": "2025-08-31T06:04:34.629Z",
            "processing_at": "2025-08-31T09:04:34.641Z",
            "completed_at": "2025-08-31T09:04:46.640Z",
            "client_id": "a1b2c3d4-e5f6-7890-abcd-ef1234567890",
            "workflow_definition_name": "Flux1 [Schnell] x prompt enhancer"
          },
          "webhook_error": {
            "workflow_job_id": "e642760b-0efe-4a0e-8b51-ee4b554e44c3",
            "error": "{\"image_job_id\":\"d6bd079f-8f87-4acd-b328-5aa17782b908\",\"error\":{\"message\":\"Invalid value for an element in the 'referenceImages' parameter. Supported formats are: PNG, JPG, and WEBP.\",\"parameter\":\"referenceImages\",\"type\":\"string[]\",\"min\":null,\"max\":null},\"success\":false}",
            "success": false
          }
        }
      },
      {
        id: "get-workflow-job",
        name: "Get Workflow Job",
        description: "Get the status and results of a workflow job",
        method: "GET",
        endpoint: "/api/workflows/workflow-jobs/workflow-job/{job_id}",
        headers: [
          {
            name: "x-api-key",
            value: "YOUR_API_KEY",
            required: true,
            description: "Your URO API key"
          }
        ],
        parameters: [
          {
            name: "job_id",
            type: "string",
            required: true,
            in: "path",
            description: "The workflow job ID"
          }
        ],
        body: null,
        responses: {
          success: {
            "success": true,
            "data": {
              "workflow_job_id": "770e8400-e29b-41d4-a716-446655440005",
              "workflow_definition_id": "550e8400-e29b-41d4-a716-446655440002",
              "input_params": {
                "clothe_image_url": "https://example.com/image/11111111-2222-3333-4444-555555555555.png",
                "person_image_url": "https://example.com/image/66666666-7777-8888-9999-000000000000.jpg"
              },
              "status": "completed",
              "cost_to_client": 0.0494,
              "created_at": "2025-08-29T20:52:47.812Z",
              "processing_at": "2025-08-29T20:52:47.818Z",
              "completed_at": "2025-08-29T20:53:10.373Z",
              "failed_at": null,
              "client_id": "880e8400-e29b-41d4-a716-446655440006",
              "workflow_definition_name": "URO VTON",
              "num_of_steps": 8,
              "num_of_completed_steps": 8,
              "results": {
                "results": [
                  {
                    "content": "https://example.com/image/aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee.jpg",
                    "image_id": "990e8400-e29b-41d4-a716-446655440007",
                    "model_id": "aa0e8400-e29b-41d4-a716-446655440008",
                    "content_type": "image",
                    "external_url": "https://example.com/image/aaaaaaaa-bbbb-cccc-dddd-eeeeeeeeeeee.jpg",
                    "image_job_id": "bb0e8400-e29b-41d4-a716-446655440009",
                    "additional_params": null
                  }
                ]
              }
            }
          }
        }
      },
      {
        id: "list-workflow-jobs",
        name: "List Workflow Jobs",
        description: "Get a list of workflow jobs with filtering options",
        method: "GET",
        endpoint: "/api/workflows/workflow-jobs",
        headers: [
          {
            name: "x-api-key",
            value: "YOUR_API_KEY",
            required: true,
            description: "Your URO API key"
          }
        ],
        parameters: [
          {
            name: "page",
            type: "integer",
            required: false,
            default: 1,
            description: "Page number"
          },
          {
            name: "limit",
            type: "integer",
            required: false,
            default: 10,
            description: "Items per page"
          },
          {
            name: "workflow_job_ids",
            type: "string",
            required: false,
            description: "Comma-separated job IDs"
          },
          {
            name: "status",
            type: "string",
            required: false,
            description: "Filter by status (pending, processing, completed, failed)"
          },
          {
            name: "workflow_definition_id",
            type: "string",
            required: false,
            description: "Filter by workflow definition ID"
          }
        ],
        body: null,
        responses: {
          success: {
            "success": true,
            "data": {
              "items": [],
              "pagination": {
                "page": "1",
                "limit": "10",
                "totalItems": 0,
                "totalPages": 0,
                "hasNextPage": false,
                "hasPrevPage": false
              }
            }
          }
        }
      }
    ]
  },
  models: {
    name: "Models",
    description: "AI models for image generation and processing",
    endpoints: [
      {
        id: "list-models",
        name: "List Models",
        description: "Get a list of available AI models",
        method: "GET",
        endpoint: "/api/models",
        headers: [
          {
            name: "x-api-key",
            value: "YOUR_API_KEY",
            required: true,
            description: "Your URO API key"
          }
        ],
        parameters: [
          {
            name: "page",
            type: "integer",
            required: false,
            default: 1,
            description: "Page number"
          },
          {
            name: "limit",
            type: "integer",
            required: false,
            default: 10,
            description: "Items per page"
          },
          {
            name: "model_type",
            type: "string",
            required: false,
            description: "Filter by model type"
          },
          {
            name: "model_name",
            type: "string",
            required: false,
            description: "Filter by model name"
          },
          {
            name: "model_description",
            type: "string",
            required: false,
            description: "Filter by description"
          }
        ],
        body: null,
        responses: {
          success: {
            "success": true,
            "data": {
              "items": [
                {
                  "model_id": "cc0e8400-e29b-41d4-a716-446655440010",
                  "model_name": "Flux 1 Dev",
                  "model_type": "image",
                  "model_description": "High-quality image generation model",
                  "model_cover_image_url": null,
                  "average_cost": 0.038200000000000005,
                  "model_cover_2_image_url": null,
                  "model_eta": 19,
                  "parameters": []
                }
              ],
              "pagination": {
                "page": 1,
                "limit": 10,
                "totalItems": 1,
                "totalPages": 1,
                "hasNextPage": false,
                "hasPrevPage": false
              }
            }
          }
        }
      },
      {
        id: "get-model-types",
        name: "Get Model Types",
        description: "Get a list of available model types",
        method: "GET",
        endpoint: "/api/models/model-types",
        headers: [
          {
            name: "x-api-key",
            value: "YOUR_API_KEY",
            required: true,
            description: "Your URO API key"
          }
        ],
        parameters: [],
        body: null,
        responses: {
          success: {
            "success": true,
            "data": [
              "chat",
              "image",
              "background_remover",
              "image_upscaler",
              "prompt_enhancer",
              "workflow",
              "advanced_workflow",
              "image_captioner",
              "tool",
              "text_generation",
              "video"
            ]
          }
        }
      },
      {
        id: "get-model",
        name: "Get Model by ID",
        description: "Get detailed information about a specific model",
        method: "GET",
        endpoint: "/api/models/model/{model_id}",
        headers: [
          {
            name: "x-api-key",
            value: "YOUR_API_KEY",
            required: true,
            description: "Your URO API key"
          }
        ],
        parameters: [
          {
            name: "model_id",
            type: "string",
            required: true,
            in: "path",
            description: "The model ID"
          }
        ],
        body: null,
        responses: {
          success: {
            "success": true,
            "data": {
              "model_id": "dd0e8400-e29b-41d4-a716-446655440011",
              "model_name": "Flux 1 Dev",
              "model_type": "image",
              "model_description": "Flux 1 dev for high-quality image generation",
              "model_cover_image_url": "https://example.com/image/12345678-90ab-cdef-1234-567890abcdef.jpg",
              "average_cost": 0.007869999999999999,
              "model_cover_2_image_url": null,
              "parameters": [],
              "loras": [],
              "controlNets": [],
              "resolution": {
                "model_id": "dd0e8400-e29b-41d4-a716-446655440011",
                "multiple_of": 64,
                "min_width": 256,
                "max_width": 2048,
                "min_height": 256,
                "max_height": 2048,
                "allowed_ratios": "1:1,3:4,4:3,16:9,9:16",
                "supported_tiers": "sd,hd"
              }
            }
          }
        }
      },
      {
        id: "run-model",
        name: "Run Model",
        description: "Execute a model with specified parameters",
        method: "POST",
        endpoint: "/api/models/run-model",
        headers: [
          {
            name: "x-api-key",
            value: "YOUR_API_KEY",
            required: true,
            description: "Your URO API key"
          },
          {
            name: "Content-Type",
            value: "application/json",
            required: true,
            description: "Request content type"
          }
        ],
        parameters: [],
        body: {
          "model_id": "ee0e8400-e29b-41d4-a716-446655440012",
          "positive_prompt": "A beautiful Galaxy Bottle in the mountains with a river behind it. Written URO in the sky.",
          "prompt_weighting": null,
          "seed": null,
          "cfg_scale": "7",
          "mask_image_url": null,
          "steps": "20",
          "lora_models": "",
          "height": "512",
          "width": "512",
          "strength": "",
          "outpaint": null,
          "control_net": null,
          "seed_image_url": null,
          "ratio": "",
          "tier": "",
          "webhook_url": "https://your-webhook-url.com/callback",
          "custom_webhook": "https://your-webhook-url.com/callback (same as webhook_url)"
        },
        responses: {
          success: {
            "success": true,
            "data": {
              "image_job_id": "ff0e8400-e29b-41d4-a716-446655440013",
              "status": "processing"
            }
          },
          error: {
            "success": false,
            "error": {
              "message": "Missing required parameter: model_id",
              "code": "VALIDATION_ERROR"
            }
          },
          "webhook_success": {
            "image_job_id": "5dbdf626-607c-44c7-9a2b-9fdcbb7d0859",
            "model_id": "a694ec6e-c3af-4822-b8c3-79d6e3a98345",
            "status": "completed",
            "input_texts": {
              "input_text": "A beautiful landscape with mountains and a sunset",
              "negative_prompt": null,
              "positive_prompt": "A beautiful landscape with mountains and a sunset"
            },
            "input_images": {
              "input_image": null,
              "mask_image_url": null,
              "seed_image_url": null
            },
            "cost_to_client": 0.0029,
            "created_at": "2025-08-31T09:17:18.492Z",
            "processing_at": "2025-08-31T09:17:18.563Z",
            "completed_at": "2025-08-31T09:17:23.806Z",
            "failed_at": null,
            "model_name": "Flux 1 Dev",
            "input_params": {
              "tier": "",
              "ratio": "",
              "steps": "20",
              "width": 512,
              "height": 512,
              "strength": "",
              "cfg_scale": 7,
              "lora_models": "",
              "positive_prompt": "A beautiful landscape with mountains and a sunset"
            },
            "duration": "5.24300000",
            "results": [
              {
                "image_id": "2e08430c-b0a6-4bba-8f9d-971fb8375747",
                "external_url": "https://example.com/image/f9974549-2f01-41d5-bb09-4e6b42fd8236.jpg",
                "image_job_id": "5dbdf626-607c-44c7-9a2b-9fdcbb7d0859",
                "additional_params": null,
                "model_id": "a694ec6e-c3af-4822-b8c3-79d6e3a98345",
                "content_type": "image",
                "content": "https://example.com/image/f9974549-2f01-41d5-bb09-4e6b42fd8236.jpg"
              }
            ],
            "success": true
          },
          "webhook_error": {
            "image_job_id": "785894c9-6944-4af1-aea3-a59a70e9fa57",
            "error": {
              "message": "Invalid value for 'positivePrompt' parameter. Positive prompt must be a string value between 2 and 3000 characters.",
              "parameter": "positivePrompt",
              "type": "string",
              "min": 2,
              "max": 3000
            },
            "success": false
          }
        }
      }
    ]
  },
  jobs: {
    name: "Jobs",
    description: "Monitor and manage image generation jobs",
    endpoints: [
      {
        id: "get-job",
        name: "Get Job by ID",
        description: "Get detailed information about a specific job",
        method: "GET",
        endpoint: "/api/image-jobs/image-job/{job_id}",
        headers: [
          {
            name: "x-api-key",
            value: "YOUR_API_KEY",
            required: true,
            description: "Your URO API key"
          }
        ],
        parameters: [
          {
            name: "job_id",
            type: "string",
            required: true,
            in: "path",
            description: "The image job ID"
          }
        ],
        body: null,
        responses: {
          success: {
            "success": true,
            "data": {
              "image_job_id": "110e8400-e29b-41d4-a716-446655440014",
              "model_id": "220e8400-e29b-41d4-a716-446655440015",
              "status": "completed",
              "input_texts": {
                "input_text": "A beautiful landscape",
                "negative_prompt": null,
                "positive_prompt": "A beautiful landscape"
              },
              "input_images": {
                "input_image": null,
                "mask_image_url": null,
                "seed_image_url": null
              },
              "cost_to_client": 0.0029,
              "created_at": "2025-08-31T04:55:03.239Z",
              "processing_at": "2025-08-31T04:55:03.242Z",
              "completed_at": "2025-08-31T04:55:06.206Z",
              "failed_at": null,
              "model_name": "Flux 1 Dev",
              "duration": "2.96400000",
              "results": [
                {
                  "image_id": "330e8400-e29b-41d4-a716-446655440016",
                  "external_url": "https://example.com/image/99999999-8888-7777-6666-555555555555.jpg",
                  "image_job_id": "110e8400-e29b-41d4-a716-446655440014",
                  "additional_params": null,
                  "model_id": "220e8400-e29b-41d4-a716-446655440015",
                  "content_type": "image",
                  "content": "https://example.com/image/99999999-8888-7777-6666-555555555555.jpg"
                }
              ]
            }
          }
        }
      },
      {
        id: "list-jobs",
        name: "List Jobs",
        description: "Get a list of image generation jobs",
        method: "GET",
        endpoint: "/api/image-jobs",
        headers: [
          {
            name: "x-api-key",
            value: "YOUR_API_KEY",
            required: true,
            description: "Your URO API key"
          }
        ],
        parameters: [
          {
            name: "page",
            type: "integer",
            required: false,
            default: 1,
            description: "Page number"
          },
          {
            name: "limit",
            type: "integer",
            required: false,
            default: 10,
            description: "Items per page"
          },
          {
            name: "image_job_ids",
            type: "string",
            required: false,
            description: "Comma-separated job IDs"
          },
          {
            name: "model_ids",
            type: "string",
            required: false,
            description: "Comma-separated model IDs"
          }
        ],
        body: null,
        responses: {
          success: {
            "success": true,
            "data": {
              "items": [],
              "pagination": {
                "page": 1,
                "limit": 10,
                "totalItems": 0,
                "totalPages": 0,
                "hasNextPage": false,
                "hasPrevPage": false
              }
            }
          }
        }
      }
    ]
  }
};

export default endpoints;
